/**
 * Single comment
 */

// Import statements
import React, {Component} from "react"
import {toUrl} from 'gatsby-source-gravatar'

/**
 * Define the SingleComment class
 */
class SingleComment extends Component {

    // render the component
    render(props) {
        const comment = this.props.comment.node
        const children = this.props.children
        const post = this.props.post
        const getAuthorNameLink = (name, url) => {
            if (url) {
                return <a href={url}>{name}</a>
            }
            return name
        }

        // get gravatar URL
        let gravatar = toUrl((comment.author.node.email || ''), 'size=64')

        // define extrea class
        let extraClass = '';

        const postAuthorDatabaseId = post.author?.node.databaseId

        // when the author of this comment is the post author
        if (comment.author.node.databaseId === postAuthorDatabaseId) {
            extraClass += ' bypostauthor';
            gravatar = post.author?.node.avatar.url.replace('s=96', 's=64')
        }

        // return the information
        return (
            <li key={comment.id} id={comment.id} className={`comment depth-${this.props.index + 1} ${extraClass}`}>
                <article className="d-flex">
                    <aside className={`media-left flex-schrink-0 mr-2`}>
                        <img src={gravatar} alt={comment.author.node.name}/>
                    </aside>
                    <section className={`media-body`}>
                        <header>
                            <span className={`author`}>
                                {getAuthorNameLink(comment.author.node.name, comment.author.node.url)}
                            </span>
                            <time className={`small`} dateTime={comment.date}>
                                <a href={`/#${comment.id}`}>{formatDate(comment.date)}</a>
                            </time>
                        </header>
                        <section className={`comment-content`}>
                            <div dangerouslySetInnerHTML={{__html: comment.content}}/>
                        </section>
                        <button className={`btn btn-primary-transparent`}
                                data-parent={comment.databaseId}>Beantwoorden
                        </button>
                    </section>
                </article>
                {children}
            </li>
        )
    }
}

/**
 * Export the SingleComment variable
 */
export default SingleComment

/**
 * Format the date in written form like: "Yesterday", "A week ago".
 * @param someDateTimeStamp
 * @returns {string}
 */
function formatDate(someDateTimeStamp) {
    let fulldays = ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"];
    let months = ["januari", "februari", "maart", "april", "meu", "juni", "juli", "augustus", "september", "oktober", "november", "december"];
    let dt = new Date(someDateTimeStamp),
        date = dt.getDate(),
        month = months[dt.getMonth()],
        //timeDiff = someDateTimeStamp - Date.now(),
        diffDays = new Date().getDate() - date,
        diffMonths = new Date().getMonth() - dt.getMonth(),
        diffYears = new Date().getFullYear() - dt.getFullYear();

    if (diffYears === 0 && diffDays === 0 && diffMonths === 0) {
        return "Vandaag";
    } else if (diffYears === 0 && diffDays === 1) {
        return "Gisteren";
    } else if (diffYears === 0 && diffDays === 2) {
        return "Eergisteren";
    } else if (diffYears === 0 && (diffDays > 2 && diffDays < 7)) {
        return fulldays[dt.getDay()];
    } else if (diffYears >= 1) {
        return date + " " + month + ", " + new Date(someDateTimeStamp).getFullYear();
    } else {
        return date + " " + month;
    }
}